
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqs9KwhDm_sKWKnnMWRjwm5ueVumaKotXd_5NjDL2zIa_kMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/faqs.vue?macro=true";
import { default as indexAUgj2RqwdwYnlQggbhUqXZsfO1nQKuc14mQ_gKisBDsMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/index.vue?macro=true";
import { default as linksw7RyjLUYY6mjWSnyGv5ie7l_tImrtp8lWwnFGgXX1swMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/links.vue?macro=true";
import { default as music0KUMj5036vNQpjaJsJBXINHWlykFICxBCAKsfcHSRtIMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/music.vue?macro=true";
import { default as venue1fsI1NPneszQCj6UXfyf9Xv0CiBfKwmvc0dpNjmI86MMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/venue.vue?macro=true";
import { default as signupQeDLXHabdMtd6wgfyFXeG7Z2HI0ZLWb3QROBNt8M0tUMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/signup.vue?macro=true";
import { default as contactswpzo3AopmCZ9lKx_LT8R7iCO2cMDXAQIUQvJWFO9OwMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/contact.vue?macro=true";
import { default as cookiesQlPFzwVbIl4sT3ynfAJOoI8XqPMK_7jkL89StA8u8JgMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/cookies.vue?macro=true";
import { default as pgh1OGAOMGcmmUrRRHkh44W6tedgmOqIZTFxZ1_SzYtp_DIMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/ig/pgh1.vue?macro=true";
import { default as editSQiTzhf6_ndfjReRpOp7uU29V7hOjK6xlmcUZrxAxvQMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/me/edit.vue?macro=true";
import { default as privacyM31oCoDxH4lU4uawzHrP2wf26bXmDBF3DUX2IdM_DHsMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/privacy.vue?macro=true";
import { default as index87GHaQLjcSKsmD_YmEJAyliqIednpGEoWHwCU8D_EgwMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/ig/index.vue?macro=true";
import { default as indexaRIzwl0UVCxT_KxShR66870GSdqf32rNY4X_LMA4_qEMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/me/index.vue?macro=true";
import { default as index9OAVKqP81JgE24RUnqgxZgrhShco05_hQnU_5q5ryNcMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/blog/index.vue?macro=true";
import { default as event_45terms5oJBuufh9cCQ3bA1GdyGQs_HRnjJZ092O7SONi84NI0Meta } from "/codebuild/output/src3940190096/src/nuxt/pages/event-terms.vue?macro=true";
import { default as _91passcode_93D0sa4uLyOh0duMArj6nLE4OwHy7bjf4dW4iwbgcDhTUMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/login/index/[passcode].vue?macro=true";
import { default as indexnKePVCUwZ9l0E9vBh3uA8zYGXYP8JLhXJ2RCsbHcwGUMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/login/index.vue?macro=true";
import { default as indexMmKjuc2l1sB1gaJVHkqFq_sQIGQrOrkhl43ooMUZiEkMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/events/index.vue?macro=true";
import { default as website_45termsRvpTKrEMrZ0pryCQ_x7Vi6xLu5yEAATen89NewNtERQMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/website-terms.vue?macro=true";
import { default as _91token_93hY3JQvvD75joxKUJL3rpW99M5EviT1N0gud9fExBY8EMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/messages/index/[idThread]/[token].vue?macro=true";
import { default as _91idThread_93rvxy90tyh_iufxm_XuTS67Muw_Zcl5UVjwnfbJnEIzgMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/messages/index/[idThread].vue?macro=true";
import { default as indexgldW9lPXDt_viOezxqonz9vZ9cQsvWWdR6FT7QsxB2wMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/messages/index.vue?macro=true";
import { default as indexzW9TlqfDmJMzIJG6EXi2wX_reTk2H3CuVgOAFe79pNoMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/subscribe/index.vue?macro=true";
import { default as indexEWpQobzM5CjWXrw5lnBpv2JzufvHOZW9ffwZP6c3Q0AMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/login-code/index.vue?macro=true";
import { default as notificationsNOmx4HTnXJJ2Ds_yXh7hXugt0b9W6Mf01Fm96EUxjw0Meta } from "/codebuild/output/src3940190096/src/nuxt/pages/me/notifications.vue?macro=true";
import { default as _91eventSlug_939KjdgviU3AGysYHUxf_ydIgw03q89zNvb_X6yXXF_3gMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/events/[eventSlug].vue?macro=true";
import { default as _91postSlug_93GJ0Tg4ghIVEZNUr9VA5Vx_ixc1YlIFbi5NR0a7Eo2RwMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/[postSlug].vue?macro=true";
import { default as indexykfMwr_dtZobxSlgcGIjL4at0TqOj_dcCasbto7Qph8Meta } from "/codebuild/output/src3940190096/src/nuxt/pages/me/subscriptions/index.vue?macro=true";
import { default as _91token_93T2Lu9mt9OUmiPQngF8dtFhLhKSZjgjCcmzVC1T7CYaoMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/unsubscribe/[email]/[token].vue?macro=true";
import { default as _91idSubscription_93m9loZTBwCveuKmUtZlXPeMhFwzfwx1Azp4aQEih4GLoMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/me/subscriptions/[idSubscription].vue?macro=true";
import { default as _91subscriptionProductSlug_93ze5UO8mtC4jBecbPMn1TwncnXp2VUcNPAztrCVS6T_IMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/subscribe/[subscriptionProductSlug].vue?macro=true";
import { default as _91token_932wcm7yKv2RckZv8pjVtOgh11xN8YJX90U4FeMDAgyVoMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/unsubscribe-mailers/[email]/[token].vue?macro=true";
import { default as registry_45event_45survival_45guiden_3ysriNdkqgHhpCy5f6BGN1YLAfks2aJVPAO7yJNfgMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/registry-event-survival-guide.vue?macro=true";
import { default as the_45dangers_45of_45giving_45feedbackvJMGFlbDgvRuKUw1y0GvstSyd2vwKavQT9JmzOyMGL4Meta } from "/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/the-dangers-of-giving-feedback.vue?macro=true";
import { default as the_45renegade_45of_45the_45swing_45familytR_c_3dzwg75_31hnrvhC81Yx6RslwCSWrs9gA232HoMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/the-renegade-of-the-swing-family.vue?macro=true";
import { default as what_45to_45expect_45at_45your_45first_45classQJreiHc74eYBdwqEawuIEy9iOapcaEAc1DvqQOU57hAMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/what-to-expect-at-your-first-class.vue?macro=true";
import { default as wsdc_45registry_45events_45we_45are_45attending2ZdQ0cgO8VF5IoFIDM4xYdkGhlGNDXS5w8FYMD6hFkoMeta } from "/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/wsdc-registry-events-we-are-attending.vue?macro=true";
import { default as where_45can_45i_45west_45coast_45swing_45in_45yorkshire7NhJvcK4hI4K5U_SqX4dvX_0x1Tli6jxgGnL_nU6ck8Meta } from "/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/where-can-i-west-coast-swing-in-yorkshire.vue?macro=true";
export default [
  {
    name: "faqs",
    path: "/faqs",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/faqs.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/index.vue")
  },
  {
    name: "links",
    path: "/links",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/links.vue")
  },
  {
    name: "music",
    path: "/music",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/music.vue")
  },
  {
    name: "venue",
    path: "/venue",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/venue.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/signup.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/contact.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/cookies.vue")
  },
  {
    name: "ig-pgh1",
    path: "/ig/pgh1",
    meta: pgh1OGAOMGcmmUrRRHkh44W6tedgmOqIZTFxZ1_SzYtp_DIMeta || {},
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/ig/pgh1.vue")
  },
  {
    name: "me-edit",
    path: "/me/edit",
    meta: editSQiTzhf6_ndfjReRpOp7uU29V7hOjK6xlmcUZrxAxvQMeta || {},
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/me/edit.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/privacy.vue")
  },
  {
    name: "ig",
    path: "/ig",
    meta: index87GHaQLjcSKsmD_YmEJAyliqIednpGEoWHwCU8D_EgwMeta || {},
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/ig/index.vue")
  },
  {
    name: "me",
    path: "/me",
    meta: indexaRIzwl0UVCxT_KxShR66870GSdqf32rNY4X_LMA4_qEMeta || {},
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/me/index.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/blog/index.vue")
  },
  {
    name: "event-terms",
    path: "/event-terms",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/event-terms.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/login/index.vue"),
    children: [
  {
    name: "login-index-passcode",
    path: ":passcode()",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/login/index/[passcode].vue")
  }
]
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/events/index.vue")
  },
  {
    name: "website-terms",
    path: "/website-terms",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/website-terms.vue")
  },
  {
    name: "messages",
    path: "/messages",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/messages/index.vue"),
    children: [
  {
    name: "messages-index-idThread",
    path: ":idThread()",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/messages/index/[idThread].vue"),
    children: [
  {
    name: "messages-index-idThread-token",
    path: ":token()",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/messages/index/[idThread]/[token].vue")
  }
]
  }
]
  },
  {
    name: "subscribe",
    path: "/subscribe",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/subscribe/index.vue")
  },
  {
    name: "login-code",
    path: "/login-code",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/login-code/index.vue")
  },
  {
    name: "me-notifications",
    path: "/me/notifications",
    meta: notificationsNOmx4HTnXJJ2Ds_yXh7hXugt0b9W6Mf01Fm96EUxjw0Meta || {},
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/me/notifications.vue")
  },
  {
    name: "events-eventSlug",
    path: "/events/:eventSlug()",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/events/[eventSlug].vue")
  },
  {
    name: "blog-posts-postSlug",
    path: "/blog/posts/:postSlug()",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/[postSlug].vue")
  },
  {
    name: "me-subscriptions",
    path: "/me/subscriptions",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/me/subscriptions/index.vue")
  },
  {
    name: "unsubscribe-email-token",
    path: "/unsubscribe/:email()/:token()",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/unsubscribe/[email]/[token].vue")
  },
  {
    name: "me-subscriptions-idSubscription",
    path: "/me/subscriptions/:idSubscription()",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/me/subscriptions/[idSubscription].vue")
  },
  {
    name: "subscribe-subscriptionProductSlug",
    path: "/subscribe/:subscriptionProductSlug()",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/subscribe/[subscriptionProductSlug].vue")
  },
  {
    name: "unsubscribe-mailers-email-token",
    path: "/unsubscribe-mailers/:email()/:token()",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/unsubscribe-mailers/[email]/[token].vue")
  },
  {
    name: "blog-posts-registry-event-survival-guide",
    path: "/blog/posts/registry-event-survival-guide",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/registry-event-survival-guide.vue")
  },
  {
    name: "blog-posts-the-dangers-of-giving-feedback",
    path: "/blog/posts/the-dangers-of-giving-feedback",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/the-dangers-of-giving-feedback.vue")
  },
  {
    name: "blog-posts-the-renegade-of-the-swing-family",
    path: "/blog/posts/the-renegade-of-the-swing-family",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/the-renegade-of-the-swing-family.vue")
  },
  {
    name: "blog-posts-what-to-expect-at-your-first-class",
    path: "/blog/posts/what-to-expect-at-your-first-class",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/what-to-expect-at-your-first-class.vue")
  },
  {
    name: "blog-posts-wsdc-registry-events-we-are-attending",
    path: "/blog/posts/wsdc-registry-events-we-are-attending",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/wsdc-registry-events-we-are-attending.vue")
  },
  {
    name: "blog-posts-where-can-i-west-coast-swing-in-yorkshire",
    path: "/blog/posts/where-can-i-west-coast-swing-in-yorkshire",
    component: () => import("/codebuild/output/src3940190096/src/nuxt/pages/blog/posts/where-can-i-west-coast-swing-in-yorkshire.vue")
  }
]